import { render, staticRenderFns } from "./ChecklistSubmissionStats.vue?vue&type=template&id=54ff7005"
import script from "./ChecklistSubmissionStats.vue?vue&type=script&lang=js"
export * from "./ChecklistSubmissionStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports